import React, { useState, useEffect } from 'react';
import { getPriceWithToppings } from './FoodDialog';
import { getModifierPrice } from './ModifierGroup/ModifierUtil';
import formatPrice from '../../../../../utils/formatPrice';
import {
    Grid,
    Typography,
    TextField,
    //IconButton,
    InputAdornment,
    ToggleButtonGroup,
    ToggleButton,
} from '@mui/material';
// import SwitchLeftIcon from '@mui/icons-material/SwitchLeft';
// import SwitchRightIcon from '@mui/icons-material/SwitchRight';

const ItemDiscount = ({
    discount,
    setDiscount,
    order,
    discountedPrice,
    setDiscountedPrice,
    showItemPriceAsTextbox = false,
    originalItemPrice,
    setOriginalItemPrice,
}) => {
    const initialDiscount =
        discount.discount_type === 'Dollar'
            ? discount.amount_off / 100
            : discount.percent_off;
    const [inputDiscountedItemPrice, setInputDiscountedItemPrice] = useState(
        (discountedPrice / 100).toFixed(2)
    );
    const [inputDiscountVal, setInputDiscountVal] = useState(initialDiscount);
    const [inputTotalAmount, setInputTotalAmount] = useState(
        order.price ? ((order.quantity * discountedPrice) / 100).toFixed(2) : ''
    );
    const [inputItemPrice, setInputItemPrice] = useState(
        showItemPriceAsTextbox && originalItemPrice
            ? (originalItemPrice / 100).toFixed(2)
            : ''
    );
    const [originalItemPriceInternal, setOriginalItemPriceInternal] = useState(
        showItemPriceAsTextbox && originalItemPrice
            ? originalItemPrice
            : getPriceWithToppings(order) + getModifierPrice(order)
    );
    useEffect(() => {
        if (showItemPriceAsTextbox && originalItemPrice) {
            setOriginalItemPriceInternal(originalItemPrice);
        } else {
            setOriginalItemPriceInternal(
                getPriceWithToppings(order) + getModifierPrice(order)
            );
        }
    }, [order, showItemPriceAsTextbox, originalItemPrice]);

    useEffect(() => {
        // Recalculate total amount when quantity or discountedPrice changes
        if (order.quantity && discountedPrice) {
            setInputTotalAmount(
                ((order.quantity * discountedPrice) / 100).toFixed(2)
            );
        }
    }, [order.quantity, discountedPrice]);
    // useEffect(() => {
    //     if (discount.discount_type === 'Dollar') {
    //       setInputDiscountedItemPrice((originalItemPrice/100 - inputDiscountVal).toFixed(2));
    //       setFinalPrice(totalOriginalPrice - inputDiscount * 100);
    //     } else {
    //       setInputDiscountedItemPrice((originalItemPrice * (100-inputDiscountVal) / 10000).toFixed(2));
    //       setFinalPrice(Math.round(totalOriginalPrice * (100-inputDiscount) / 100));
    //     }
    //   }, [discount]);

    const updateDiscount = (value) => {
        setInputDiscountVal(value);
        let input = value;
        if (value === '') input = 0;

        if (value !== '') {
            input = Number(value);
            if (isNaN(input)) return;
        }

        if (discount.discount_type === 'Dollar') {
            setDiscount({
                discount_type: 'Dollar',
                amount: input * 100,
                amount_off: input * 100,
            });
        } else {
            setDiscount({
                discount_type: 'Percent',
                amount: Math.round((originalItemPriceInternal * input) / 100),
                percent_off: input,
            });
        }
        //compute final price
        const newDiscountedPrice =
            discount.discount_type === 'Percent'
                ? Math.round((originalItemPriceInternal * (100 - value)) / 100)
                : originalItemPriceInternal - value * 100;

        setInputDiscountedItemPrice(
            discount.discount_type === 'Percent'
                ? ((originalItemPriceInternal * (100 - value)) / 10000).toFixed(
                      2
                  )
                : (originalItemPriceInternal / 100 - value).toFixed(2)
        );
        setDiscountedPrice(newDiscountedPrice);
        setInputTotalAmount(
            ((order.quantity * newDiscountedPrice) / 100).toFixed(2)
        );
    };

    const toggleDiscountMethod = () => {
        //debugger;
        if (discount.discount_type === 'Dollar') {
            setDiscount({
                discount_type: 'Percent',
                percent_off:
                    inputDiscountVal !== '' && !isNaN(Number(inputDiscountVal))
                        ? inputDiscountVal
                        : 0,
                amount:
                    inputDiscountVal !== '' && !isNaN(Number(inputDiscountVal))
                        ? Math.round(
                              (originalItemPriceInternal * inputDiscountVal) /
                                  100
                          )
                        : 0,
            });
        } else {
            setDiscount({
                discount_type: 'Dollar',
                amount_off:
                    inputDiscountVal !== '' && !isNaN(Number(inputDiscountVal))
                        ? inputDiscountVal * 100
                        : 0,
                amount:
                    inputDiscountVal !== '' && !isNaN(Number(inputDiscountVal))
                        ? inputDiscountVal * 100
                        : 0,
            });
        }

        //compute final price
        const newDiscountedPrice =
            discount.discount_type === 'Dollar'
                ? Math.round(
                      (originalItemPriceInternal * (100 - inputDiscountVal)) /
                          100
                  )
                : originalItemPriceInternal - inputDiscountVal * 100;

        setInputDiscountedItemPrice(
            discount.discount_type === 'Dollar'
                ? (
                      (originalItemPriceInternal * (100 - inputDiscountVal)) /
                      10000
                  ).toFixed(2)
                : (originalItemPriceInternal / 100 - inputDiscountVal).toFixed(
                      2
                  )
        );
        setDiscountedPrice(newDiscountedPrice);
        setInputTotalAmount(
            ((order.quantity * newDiscountedPrice) / 100).toFixed(2)
        );
    };

    const updateDiscountedItemPrice = (value) => {
        //debugger;
        setInputDiscountedItemPrice(value);
        let input = value;
        if (value === '') input = 0;

        if (value !== '') {
            if (input !== Number(value).toString()) {
                setDiscountedPrice(input);
                return;
            }
            input = Number(value);
            if (isNaN(input)) return;
        }

        const newDiscountedPrice = input * 100;
        setDiscountedPrice(newDiscountedPrice);
        setInputTotalAmount(
            ((order.quantity * newDiscountedPrice) / 100).toFixed(2)
        );

        if (discount.discount_type === 'Dollar') {
            setDiscount({
                discount_type: 'Dollar',
                amount_off: originalItemPriceInternal - input * 100,
                amount: originalItemPriceInternal - input * 100,
            });
            setInputDiscountVal(
                (originalItemPriceInternal / 100 - input).toFixed(2)
            );
        } else {
            setDiscount({
                discount_type: 'Percent',
                percent_off:
                    ((originalItemPriceInternal - input * 100) /
                        originalItemPriceInternal) *
                    100,
                amount: originalItemPriceInternal - input * 100,
            });
            setInputDiscountVal(
                ((originalItemPriceInternal - input * 100) /
                    originalItemPriceInternal) *
                    100
            );
        }
    };

    const updateTotalAmount = (value) => {
        //debugger;
        setInputTotalAmount(value);

        if (value === '') {
            // Allow empty value for user input
            return;
        }

        let totalAmt = Number(value);
        if (isNaN(totalAmt)) return;

        //let finalAmtPerItem = (totalAmt / order.quantity).toFixed(2);
        let finalAmtPerItem =
            Math.round((totalAmt / order.quantity) * 100) / 100;

        setDiscountedPrice(finalAmtPerItem * 100);
        setInputDiscountedItemPrice(finalAmtPerItem);
        if (discount.discount_type === 'Dollar') {
            setDiscount({
                discount_type: 'Dollar',
                amount_off: originalItemPriceInternal - finalAmtPerItem * 100,
                amount: originalItemPriceInternal - finalAmtPerItem * 100,
            });
            setInputDiscountVal(
                (originalItemPriceInternal / 100 - finalAmtPerItem).toFixed(2)
            );
        } else {
            setDiscount({
                discount_type: 'Percent',
                percent_off:
                    ((originalItemPriceInternal - finalAmtPerItem * 100) /
                        originalItemPriceInternal) *
                    100,
                amount: originalItemPriceInternal - finalAmtPerItem * 100,
            });
            setInputDiscountVal(
                ((originalItemPriceInternal - finalAmtPerItem * 100) /
                    originalItemPriceInternal) *
                    100
            );
        }
    };

    const updateItemPrice = (value) => {
        setInputItemPrice(value);
        let input = value;
        if (value === '') {
            setOriginalItemPrice && setOriginalItemPrice(0);
            setOriginalItemPrice(0);
            setDiscountedPrice(0);
            setInputDiscountedItemPrice('');
            setInputDiscountVal('');
            setInputTotalAmount('');
            return;
        }

        if (value !== '') {
            input = Number(value);
            if (isNaN(input)) return;
        }

        const newItemPrice = input * 100;
        setOriginalItemPrice && setOriginalItemPrice(newItemPrice);
        setOriginalItemPrice(newItemPrice);

        let newDiscountedPrice;

        // If no discount applied yet, set discounted price same as item price
        if (!discountedPrice || discountedPrice === 0) {
            newDiscountedPrice = newItemPrice;
            setDiscountedPrice(newDiscountedPrice);
            setInputDiscountedItemPrice(input.toFixed(2));
            setDiscount({
                discount_type: 'Dollar',
                amount: 0,
                amount_off: 0,
            });
            setInputDiscountVal('');
        } else {
            // Keep the existing discounted price and recalculate discount
            newDiscountedPrice = discountedPrice;
            if (discount.discount_type === 'Dollar') {
                const discountAmount = newItemPrice - discountedPrice;
                setDiscount({
                    discount_type: 'Dollar',
                    amount_off: discountAmount,
                    amount: discountAmount,
                });
                setInputDiscountVal((discountAmount / 100).toFixed(2));
            } else {
                const discountPercent =
                    ((newItemPrice - discountedPrice) / newItemPrice) * 100;
                setDiscount({
                    discount_type: 'Percent',
                    percent_off: discountPercent,
                    amount: newItemPrice - discountedPrice,
                });
                setInputDiscountVal(discountPercent.toFixed(2));
            }
        }

        //Update total amount using the correct discounted price
        if (order.quantity && newDiscountedPrice) {
            setInputTotalAmount(
                ((order.quantity * newDiscountedPrice) / 100).toFixed(2)
            );
        }
    };

    return (
        <Grid
            container
            spacing={2}
            sx={{
                border: 1,
                borderRadius: 2,
                m: 1,
                pb: 1,
                width: 'fit-content',
            }}
        >
            <Grid item xs={10}>
                {showItemPriceAsTextbox ? (
                    <TextField
                        label="Item Price"
                        size="small"
                        value={inputItemPrice}
                        onChange={(e) => updateItemPrice(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    $
                                </InputAdornment>
                            ),
                        }}
                        sx={{ width: '100%' }}
                    />
                ) : (
                    <Typography xs={12} sx={{ fontFamily: 'Roboto' }}>
                        {`Item Price: ${formatPrice(
                            originalItemPriceInternal / 100
                        )}`}
                    </Typography>
                )}
            </Grid>

            <Grid
                item
                xs={9}
                sm={6}
                verticalAlign={'middle'}
                alignItems={'center'}
            >
                <TextField
                    size="small"
                    label="Item Discount"
                    value={inputDiscountVal}
                    onChange={(e) => updateDiscount(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment
                                position="start"
                                sx={{
                                    //height: '50%',
                                    alignItems: 'center', // centers toggle vertically
                                    //m: 1,
                                    mr: 1.5,
                                    ml: 0,
                                }}
                            >
                                <ToggleButtonGroup
                                    value={discount.discount_type}
                                    exclusive
                                    onChange={toggleDiscountMethod}
                                    sx={{
                                        height: 'auto', // don't force full height
                                        my: 0.2, // adds vertical gap inside the TextField
                                    }}
                                >
                                    <ToggleButton
                                        value="Dollar"
                                        sx={{
                                            px: 1, // reduce horizontal padding
                                            py: 0.2, // reduce vertical padding
                                            minWidth: '36px',
                                            fontSize: '0.8rem',
                                        }}
                                    >
                                        $
                                    </ToggleButton>
                                    <ToggleButton
                                        value="Percent"
                                        sx={{
                                            px: 1, // reduce horizontal padding
                                            py: 0.2, // reduce vertical padding
                                            minWidth: '36px',
                                            fontSize: '0.8rem',
                                        }}
                                    >
                                        %
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </InputAdornment>
                        ),
                    }}
                />
            </Grid>

            <Grid item xs={9} sm={6}>
                <TextField
                    label="Discounted Item Price"
                    size="small"
                    //sx={{ width: '45%' }}
                    value={inputDiscountedItemPrice}
                    onChange={(e) => updateDiscountedItemPrice(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                        ),
                    }}
                />
            </Grid>
            <Grid item xs={9}>
                <TextField
                    label="Total Amount (price x quantity)"
                    size="small"
                    // sx={{ width: '45%' }}
                    value={inputTotalAmount}
                    onChange={(e) => updateTotalAmount(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                        ),
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default ItemDiscount;
